// vim: tabstop=8 softtabstop=0 noexpandtab shiftwidth=8 nosmarttab

import EventTarget from '@ungap/event-target';
import {
	MAX_BACKOFF_TIMEOUT,
	MIN_BACKOFF_TIMEOUT,
} from './config.js';

export class DesiredStateEventSource extends EventTarget {
	protected _url: string;
	protected _sse?: EventSource;
	protected _timer_id?: ReturnType<typeof setTimeout>;
	protected _is_shutdown: boolean;

	constructor(url: string) {
		super();
		this._url = url;
		this._sse = undefined;
		this._is_shutdown = false;
		this._scheduleConnection();
	}

	get url(): string {
		return this._url;
	}

	set url(value: string) {
		if(this._is_shutdown) {
			return;
		}
		this._close();
		this._url = value;
		this._scheduleConnection();
	}

	shutdown(): void {
		this._is_shutdown = true;
		this._close();
	}

	_scheduleConnection(): void {
		if(this._is_shutdown) {
			return;
		}
		this._timer_id = setTimeout(() => this._poll(), this._backoffTimeout());
	}

	// a random integer between two values, inclusive
	_backoffTimeout(): number {
		return Math.floor(Math.random() * (MAX_BACKOFF_TIMEOUT - MIN_BACKOFF_TIMEOUT + 1)) + MIN_BACKOFF_TIMEOUT;
	}

	_close(): void {
		clearTimeout(this._timer_id);
		this._timer_id = undefined;
		if(this._sse) {
			if(this._sse.readyState !== EventSource.CLOSED) {
				this._sse.close();
			}
			this._sse = undefined;
		}
	}

	_poll(): void {
		this._timer_id = undefined;
		this._sse = new EventSource(this.url);
		this._sse.addEventListener('open', (event) => this._onOpen(event));
		this._sse.addEventListener('error', (event) => this._onError(event));
		this._sse.addEventListener('message', (event) => this._onMessage(event));
		this._sse.addEventListener('shutdown', (event) => this._onShutdown(event));
	}

	_onOpen(event: Event): void {
		console.log('onOpen', event);
	}

	_onError(event: Event): void {
		console.log('onError', event);
		this._close();
		this._scheduleConnection();
	}

	_onMessage(event: MessageEvent): void {
		console.log('_onMessage', event);
		this.dispatchEvent(new Event('message'));
	}

	_onShutdown(event: Event): void {
		console.log('onShutdown', event);
		this.shutdown();
	}
}
